import React from 'react';
import { motion } from 'framer-motion';

const pageVariants = {
    initial: { 
        opacity: 0, 
        y: 12,
        filter: 'blur(4px)'
    },
    animate: { 
        opacity: 1, 
        y: 0,
        filter: 'blur(0px)'
    },
    exit: { 
        opacity: 0, 
        y: -8,
        filter: 'blur(4px)'
    }
};

const pageTransition = {
    duration: 0.5,
    ease: [0.25, 0.46, 0.45, 0.94] // Smooth deceleration
};

const PageTransition = ({ children }) => {
    return (
        <motion.div
            variants={pageVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={pageTransition}
            style={{ width: '100%' }}
        >
            {children}
        </motion.div>
    );
};

export default PageTransition;
